import React from "react";
import Bag2 from "./assets/icons/bag2.png";
// import Icon4 from "./assets/icons/icon4.png";
// import Icon3 from "./assets/icons/icon3.png";
import Time from "./assets/icons/time.png";
import Filter from "./assets/icons/filter.png";
import Filter3 from "./assets/icons/filter3.png";
import Print from "./assets/icons/print.png";
import Download from "./assets/icons/download.png";
import Plus from "./assets/icons/plus.png";
import Circles from "./assets/icons/circles.png";
import Search from "./assets/icons/search.png";
import HeroImg from "./assets/images/hero-appointment.png";
import Tv from "./assets/images/tv.png";
import Nurse from "./assets/images/nurse.png";
import Nurses from "./assets/images/nurses.png";
import Lab from "./assets/images/lab.png";
import Lab1 from "./assets/images/lab2.png";
import Lab3 from "./assets/images/lab3.png";
import Arrow from "./assets/icons/arrow.png";
import Shield from "./assets/icons/shield (2).png";
import Armour from "./assets/icons/armour.png";
import Pipette from "./assets/icons/pipette.png";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();

const Services = () => {
  const services = [
    {
      id: 1,
      img: Tv,
      icon: Plus,
      service: "Diagnostic Testing",
      description: "Comprehensive blood work and specialized laboratory tests",
    },
    {
      id: 2,
      img: Nurse,
      icon: Bag2,
      service: "Medical Imaging",
      description: "Advanced imaging including X-ray, MRI, and CT scans",
    },
    {
      id: 3,
      icon: Armour,
      img: Lab1,
      service: "Laboratory Services",
      description: "Regular health screenings and preventive care",
    },
    {
      id: 4,
      img: Lab3,
      icon: Shield,
      service: "Health Screenings",
      description: "Advanced diagnostic procedures and specialized testing",
    },
    {
      id: 5,
      img: Nurses,
      icon: Pipette,
      service: "Specialized Examinations",
      description: "Advanced diagnostic procedures and specialized testing",
    },
    {
      id: 6,
      img: Lab,
      icon: Circles,
      service: "Remote Consultations",
      description: "Advanced diagnostic procedures and specialized testing",
    },
  ];

  const laboratoryTests = [
    {
      id: 1,
      test: "PACKED CELL VOLUME (PCV)",
      time: "15MINS",
      filter: "EDTA/ 2MLS",
      price: 2000,
    },
    {
      id: 2,
      test: "FULL BLOOD COUNT (FBC)",
      time: "15MINS",
      filter: "EDTA/ 2MLS",
      price: 5000,
    },
    {
      id: 3,
      test: "ERYTHROCYTE SEDIMENTATION RATE (ESR)",
      time: "15MINS",
      filter: "EDTA/ 2MLS",
      price: 8000,
    },
    {
      id: 4,
      test: "HEMOGLOBIN GENOTYPE",
      time: "15MINS",
      filter: "EDTA/ 2MLS",
      price: 3500,
    },
    {
      id: 5,
      test: "PACKED CELL VOLUME (PCV)",
      time: "15MINS",
      filter: "EDTA/ 2MLS",
      price: 3500,
    },
    {
      id: 6,
      test: "BLOOD GROUP",
      time: "15MINS",
      filter: "EDTA/ 2MLS",
      price: 3000,
    },
  ];

  const testData = [
    {
      id: 1,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 2,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
    {
      id: 3,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 4,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
    {
      id: 5,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 6,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
    {
      id: 7,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 8,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
    {
      id: 9,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 10,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
    {
      id: 11,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 12,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
    {
      id: 13,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 14,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
    {
      id: 15,
      test: "PACKED CELL VOLUME (PCV)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "2,000",
      oddNo: true,
    },
    {
      id: 16,
      test: "FULL BLOOD COUNT (FBC)",
      duration: "15MINS",
      sample: "EDTA/ 2MLS",
      price: "5,000",
      odddNo: false,
    },
  ];

  const specialService = [
    {
      id: 1,
      service: "OBSTETRICS",
      amount: "3,000",
      oddNo: true,
    },
    {
      id: 2,
      service: "PELVIC",
      amount: "4,000",
      oddNo: false,
    },
    {
      id: 3,
      service: "ABDOMINOPELVIC",
      amount: "6,000",
      oddNo: true,
    },
    {
      id: 4,
      service: "BIOPHYSICAL PROFILE",
      amount: "5,000",
      oddNo: false,
    },
    {
      id: 5,
      service: "OBSTETRICS",
      amount: "3,000",
      oddNo: true,
    },
    {
      id: 6,
      service: "PELVIC",
      amount: "4,000",
      oddNo: false,
    },
    {
      id: 7,
      service: "ABDOMINOPELVIC",
      amount: "6,000",
      oddNo: true,
    },
    {
      id: 8,
      service: "BIOPHYSICAL PROFILE",
      amount: "5,000",
      oddNo: false,
    },
  ];

  const navigate = useNavigate();
  return (
    <div>
      {/* <section
        data-aos="fade-in"
        data-aos-delay="50"
        data-aos-duration="2000"
        className="bg-gradient-to-b from-yellow to-white flex flex-col items-center justify-center py-16"
      >
        <h1 className="text-primaryPurple text-center md:text-2xl text-xl font-semibold">
          Laboratory Services & Price List 2025
        </h1>
        <p className="text-sm">Comprehensive Medical Testing Solutions</p>
      </section> */}

      <section
        style={{ backgroundImage: `url(${HeroImg})` }}
        className="w-full h-[60vh] md:h-[70vh] lg:h-[100vh] relative  flex items-start justify-center flex-col gap-3 bg-center bg-cover"
      >
        {/* <div className="bg-gradient-to-r md:h-[70vh] lg:h-[100vh] from-[#1C022180]/100 to-[#1C022180]/50 h-[80vh] w-full absolute top-0"></div> */}
        <div
          data-aos="fade-in"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="z-10 lg:px-24 md:px-10 px-4 "
        >
          <div className="lg:w-[75%] md:w-[85%] text-white flex flex-col gap-4">
            <h1 className="md:text-5xl  text-3xl text-white font-semibold md:leading-[3.5rem]">
              Laboratory Services & Price List 2025
            </h1>
            <p className="md:text-lg text-base lg:text-base md:w-[70%] lg:w-full">
              Comprehensive Medical Testing Solutions
            </p>
          </div>
        </div>
      </section>

      <div className="py-8 text-center">
        <h1 className="text-primaryPurple font-semibold">Our Services</h1>
        <p className="text-sm">Comprehensive medical diagnostic solutions</p>
      </div>

      <div
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        className="grid place-items-center lg:px-24 md:px-10 px-4 lg:grid-cols-3  md:grid-cols-2 grid-cols-1  gap-3 max-w-full  "
      >
        {services?.map((item) => (
          <div
            key={item?.id}
            className="flex md:w-[25rem] rounded-3xl lg:w-[22rem] w-[22rem] flex-col  gap-2 bg-white border-[1px] border-gray-300 "
          >
            <img src={item.img} className="h-[40%] rounded-t-3xl" alt="" />
            <div className=" py-8 px-6">
              <img src={item?.icon} className="w-[2rem]" alt="" />
              <h1 className="font-semibold text-primaryPurple">
                {item?.service}
              </h1>
              <p className="text-gray-600 text-sm">{item?.description}</p>
              <p className="pt-5 flex items-center gap-2">
                <p className="text-[0.75rem] text-primaryPurple">Learn more</p>
                <img src={Arrow} className="w-[0.8rem] font-semibold" alt="" />
              </p>
            </div>
          </div>
        ))}
      </div>

      <div
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        className="my-24 lg:px-24 md:px-10 px-4"
      >
        <h1 className="text-xl font-semibold pb-2 text-primaryPurple">
          Laboratory Tests
        </h1>
        <div className="grid place-items-center lg:grid-cols-3  md:grid-cols-2 grid-cols-1   gap-3 max-w-full  ">
          {laboratoryTests?.map((item) => (
            <div
              key={item?.id}
              className="flex md:w-[23rem] lg:w-[22rem] w-[22rem] h-[13rem] flex-col  gap-2 bg-white rounded-lg py-8 px-6"
            >
              <div className="flex items-center justify-between">
                <p className="text-primaryPurple font-semibold">{item?.test}</p>
                <img src={Filter3} alt="" />
              </div>
              <div className="flex items-center gap-3 text-sm">
                <img src={Time} alt="" />
                <p>{item?.time}</p>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <img src={Filter} alt="" />
                <p>{item?.filter}</p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-primaryPurple font-semibold">
                  {item?.price}
                </p>
                <button className="text-white bg-yellow rounded-full px-6 py-2 text-[0.7rem]">
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        className="lg:px-24 md:px-10 px-4 py-5 flex items-center md:flex-row flex-col gap-4 justify-between"
      >
        <form
          action=""
          className="bg-gray-200 py-1 px-2 flex items-center gap-2 md:w-[10rem] w-[70%] rounded-md"
        >
          <img src={Search} alt="" />
          <input
            type="text"
            placeholder="Search tests..."
            className="w-[90%] bg-transparent outline-none placeholder:text-sm"
          />
        </form>

        <div className="flex items-center gap-3">
          <button className="flex items-center gap-2 px-4 py-2 bg-primaryPurple text-sm rounded-md text-white">
            <img src={Download} className="w-[]" alt="" />
            <p>Download PDF</p>
          </button>

          <div className="flex items-center text-sm gap-1 text-primaryPurple">
            <img src={Print} alt="" />
            <p>Print List</p>
          </div>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-duration="1000"
        className=" lg:px-24 md:px-10 py-5 w-[100%] overflow-auto"
      >
        <h1 className="text-xl font-semibold pb-2 text-primaryPurple">
          Laboratory Tests
        </h1>
        <table className="w-full ">
          <tr className=" text-white bg-primaryPurple w-full text-[0.75rem]">
            <td className="py-4 px-6">Test Name</td>
            <td className="py-4 px-6">Duration</td>
            <td className="py-4 px-6">Sample Required</td>
            <td className="py-4 px-6">Price (N)</td>
          </tr>
          {testData?.map((item) => (
            <tr
              className={`md:text-[0.75rem] text-[0.6rem] text-gray-600 ${
                item?.oddNo ? "bg-white" : "bg-purple-50"
              }`}
              key={item?.id}
            >
              <td className="py-4 px-6">{item?.test}</td>
              <td className="py-4 px-6">{item?.duration}</td>
              <td className="py-4 px-6">{item?.sample}</td>
              <td className="py-4 px-6">{item?.price}</td>
            </tr>
          ))}
        </table>
      </div>

      <div className=" lg:px-24 md:px-10 py-5 w-[100%] overflow-x-">
        auto
        <h1 className="text-xl font-semibold pb-2 text-primaryPurple">
          Ultrasound & Special Services
        </h1>
        <table className="w-full ">
          <tr className=" text-white bg-primaryPurple w-full text-[0.75rem]">
            <td className="py-4 px-6">Service</td>
            <td className="py-4 px-6 text-right">Price (N)</td>
          </tr>
          {specialService?.map((item) => (
            <tr
              className={`md:text-[0.75rem] text-[0.6rem] text-gray-600 ${
                item?.oddNo ? "bg-white" : "bg-purple-50"
              }`}
              key={item?.id}
            >
              <td className="py-4 px-6">{item?.service}</td>
              <td className="py-4 px-6 text-right">{item?.amount}</td>
            </tr>
          ))}
        </table>
      </div>

      <section className=" w-[80%] rounded-2xl mx-auto bg-primaryPurple gap-3 text-white py-5 flex flex-col items-center justify-center h-[14rem] my-8">
        <h1 className="text-xl font-bold">Need to Book a Test?</h1>
        <p className="md:text-sm text-[0.75rem] w-[60%] md:w-full text-center">
          Contact us for appointments and emergency testing
        </p>

        <div className="flex items-center gap-3 md:flex-row flex-col">
          <button
            onClick={() => navigate("/book-appointment")}
            className="text-primaryPurple font-semibold bg-white rounded-md py-3 px-7"
          >
            Book Appointment
          </button>
          <p className="text-sm md:text-ellipsis">Emergency Testing</p>
        </div>
      </section>
    </div>
  );
};

export default Services;
